import NotExistedErrorIcon from '@/assets/svg/not-existed-error.svg?react';
import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import { ErrorCode } from '@/shared/constant/error/ErrorCode';
import type { ErrorCodeMessageType } from '@/shared/constant/error/ErrorCodeMessageType';
import { Button } from 'aui';
import { FoxIconFlipBackward } from 'aui-biz-icons';
import clsx from 'clsx';
import React from 'react';

export type InvalidPathErrorProps = {
  value: ErrorCodeMessageType;
  className?: string;
};

export function InvalidPathError(props: InvalidPathErrorProps) {
  const { className, value } = props;

  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);
  const homeLink = React.useMemo(() => {
    if (value.errorCode !== ErrorCode.InvalidPath) {
      return undefined;
    }
    return value.extra?.homeLink ?? '/';
  }, [value]);

  return (
    <div
      className={clsx(
        'flex w-auto flex-col items-center justify-center max-os:p-5 os:w-[480px]',
        className,
      )}
    >
      <NotExistedErrorIcon />

      <div className="align-center mt-8 flex justify-center text-center text-2xl font-semibold text-color">
        {clientI18n('onlineShare.resource.notExisted.title')}
      </div>

      <div className="align-center mt-2 text-center text-lg font-400 text-secondary">
        {clientI18n('onlineShare.resource.notExisted.subTitle')}
      </div>

      {!!homeLink && (
        <Button
          type="primary"
          theme="primary"
          className="mt-8"
          onClick={() => {
            window.location.href = homeLink;
          }}
          icon={<FoxIconFlipBackward />}
        >
          {clientI18n('backToHome')}
        </Button>
      )}
    </div>
  );
}
